import { INovaGuiaRecolhimento } from 'interfaces/IGuiaRecolhimento';

const validarCampoTexto = (value?: string | number): boolean => {
  return value === undefined || value === null || value === '';
};

const validarMesAno = (value?: number): boolean => {
  return value === undefined || value === null || value === 0;
};

const validateCampoNumero = (value?: number): boolean => {
  return value === undefined || value === null || value === -1;
};

const validateCampoData = (value?: string): boolean => {
  return value === undefined || value === null || value === '';
};

const retornarCamposObrigatorios = (isEdicaoDadosRecolhimento: boolean, isProcessoVencido: boolean) => {
  type ValidacaoCampo = {
    field: keyof INovaGuiaRecolhimento;
    label: string;
    validate?: (value?: any) => boolean;
  };

  const CAMPOS_OBRIGATORIOS: ValidacaoCampo[] = [
    { field: 'competenciaMes', label: 'Mês', validate: validarMesAno },
    { field: 'competenciaAno', label: 'Ano', validate: validarMesAno },
    { field: 'numeroProcesso', label: 'Processo', validate: validarCampoTexto },
    { field: 'municipio', label: 'Município', validate: validateCampoNumero },
    { field: 'substancia', label: 'Substância', validate: validarCampoTexto },
  ];

  if (isProcessoVencido) {
    CAMPOS_OBRIGATORIOS.push({
      field: 'dataSolicitacaoRenovacaoPlg',
      label: 'Data de Solicitação de Renovação PLG',
      validate: validateCampoData,
    });
  }

  const CAMPOS_OBRIGATORIOS_EDICAO: ValidacaoCampo[] = [];

  if (isProcessoVencido) {
    CAMPOS_OBRIGATORIOS_EDICAO.push({
      field: 'dataSolicitacaoRenovacaoPlg',
      label: 'Data de Solicitação de Renovação PLG',
      validate: validateCampoData,
    });
  }

  return isEdicaoDadosRecolhimento ? CAMPOS_OBRIGATORIOS_EDICAO : CAMPOS_OBRIGATORIOS;
};

const validarCamposObrigatorios = (
  formValues: INovaGuiaRecolhimento,
  isEdicaoDadosRecolhimento: boolean,
  isProcessoVencido: boolean
) => {
  const camposObrigatorios = retornarCamposObrigatorios(isEdicaoDadosRecolhimento, isProcessoVencido);

  const camposInvalidos = [];

  for (const campo of camposObrigatorios) {
    const testeValidacao = campo.validate || validarCampoTexto || validateCampoData;

    if (testeValidacao(formValues[campo.field])) {
      camposInvalidos.push(campo.label);
    }
  }

  if (camposInvalidos.length === camposObrigatorios.length && camposInvalidos.length > 0) {
    return 'Por favor, preencha corretamente todos os campos';
  } else if (camposInvalidos.length >= 2) {
    return `Por favor, preencha corretamente os campos "${camposInvalidos[0]}" e "${camposInvalidos[1]}"`;
  } else if (camposInvalidos.length === 1) {
    return `Por favor, preencha corretamente o campo "${camposInvalidos[0]}"`;
  } else {
    return '';
  }
};

export const validarDadosRecolhimento = (
  formValues: INovaGuiaRecolhimento,
  isEdicaoDadosRecolhimento: boolean,
  isProcessoVencido: boolean
) => {
  return validarCamposObrigatorios(formValues, isEdicaoDadosRecolhimento, isProcessoVencido);
};
